<div class="flex flex-col gap-1">
  <p-inputGroup [ngClass]="'vat-state-' + badgeState()">
    <input
      pInputText
      type="text"
      [attr.data-testid]="dataTestId()"
      [formControl]="formControl"
      (blur)="onVatIdBlur()"
    />
    <p-button
      [attr.data-testid]="'vat-check-menu-button'"
      [disabled]="isChecking()"
      [pTooltip]="vatTooltip()"
      tooltipPosition="top"
      styleClass="p-button-outlined flex items-center gap-1.5"
      (onClick)="toggleMenu($event, vatIdMenu)"
    >
      <i class="fas" [ngClass]="isChecking() ? 'fa-spinner fa-spin' : 'fa-school-circle-check'"></i>
      <i class="fas fa-chevron-down text-xs"></i>
    </p-button>
  </p-inputGroup>

  <p-menu #vatIdMenu [model]="menuItems" appendTo="body" [popup]="true">
    <ng-template #item let-item>
      <a pRipple class="flex items-center p-menu-item-link" [attr.data-testid]="item.datatestId">
        <span class="p-menu-item-icon" [class]="item.icon"></span>
        <span class="p-menu-item-label ml-2">{{ item.label }}</span>
      </a>
    </ng-template>
  </p-menu>
</div>
